// 1. store/modalSlice.js
import { createSlice } from '@reduxjs/toolkit'

const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        showEditProfileModal: false,
        showSuccessModal: false
    },
    reducers: {
        openEditProfileModal: (state) => {
            state.showEditProfileModal = true
        },
        closeEditProfileModal: (state) => {
            state.showEditProfileModal = false
        },
        openSuccessModal: (state) => {
            state.showSuccessModal = true
        },
        closeSuccessModal: (state) => {
            state.showSuccessModal = false
        },
        handleEditProfileSuccess: (state) => {
            state.showEditProfileModal = false
            state.showSuccessModal = true
        }
    }
})

export const {
    openEditProfileModal,
    closeEditProfileModal,
    openSuccessModal,
    closeSuccessModal,
    handleEditProfileSuccess
} = modalSlice.actions

export default modalSlice.reducer